module.exports = __webpack_public_path__ + "img/9_19.2dfd1f0d.png";